import React from "react";
import Link from "gatsby-link";

export const Breadcrumbs = ({ items }) => {
  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      <ol className="breadcrumbs-list">
        <li className="breadcrumbs-item">
          <Link to="/">Home</Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="breadcrumbs-item">
            <span className="breadcrumbs-separator">/</span>
            {item.path ? (
              <Link to={item.path}>{item.label}</Link>
            ) : (
              <span className="breadcrumbs-current">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};


// WEBPACK FOOTER //
// ./src/components/Breadcrumbs.jsx